import { render } from "./VerticalPhotoCarousel.vue?vue&type=template&id=65341eb8&scoped=true&bindings={\"folders\":\"props\",\"globalOffset\":\"data\",\"stub\":\"data\",\"animationFrameId\":\"data\",\"centeringAnimation\":\"data\",\"photoHeight\":\"data\",\"containerHeight\":\"data\",\"totalHeight\":\"options\",\"setActiveFolder\":\"options\",\"getPhotoStyle\":\"options\",\"startAnimationLoop\":\"options\",\"updateStub\":\"options\"}"
import script from "./VerticalPhotoCarousel.vue?vue&type=script&lang=js"
export * from "./VerticalPhotoCarousel.vue?vue&type=script&lang=js"

import "./VerticalPhotoCarousel.vue?vue&type=style&index=0&id=65341eb8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65341eb8"

export default script